"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _framerMotion = require("framer-motion");

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _close = _interopRequireDefault(require("./close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      background: "#FFFFFF",
      boxShadow: "0 0 10px -2px rgb(0 0 0 / 5%)",
      left: 0,
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(3, 7, 3, 3),
      position: "fixed",
      top: 100,
      width: "100%",
      zIndex: theme === null || theme === void 0 ? void 0 : theme.zIndex.drawer,
      "& .menu-01-mobile-close": {
        padding: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
        position: "absolute",
        right: theme === null || theme === void 0 ? void 0 : theme.spacing(2),
        top: theme === null || theme === void 0 ? void 0 : theme.spacing(1)
      }
    },
    container: {
      position: "relative"
    }
  };
});
var animation = {
  hidden: {
    y: -30
  },
  visible: {
    y: 0
  }
};

var DesktopSubContainer = function DesktopSubContainer(props) {
  var css = useStyles();
  var action = props.action,
      disableClose = props.disableClose,
      handleClose = props.handleClose,
      iconClose = props.iconClose;
  (0, _react.useEffect)(function () {
    document.body.appendChild(el.current);
    return function () {
      if (el.current.parentElement) {
        el.current.parentElement.removeChild(el.current);
      }
    };
  }, []);
  var el = (0, _react.useRef)(document.createElement("div"));
  el.current.className = "menu-01-desktop-overlay-parent";
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    onClickAway: function onClickAway() {
      handleClose(0);
    }
  }, /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    initial: "hidden",
    animate: "visible",
    variants: animation,
    className: (0, _clsx.default)("menu-01-desktop-overlay", css.root),
    onMouseLeave: function onMouseLeave() {
      if (action !== "mouseenter") return;
      handleClose();
    },
    onMouseEnter: function onMouseEnter() {
      if (action !== "mouseenter") return;
      disableClose();
    }
  }, action === "click" && /*#__PURE__*/_react.default.createElement(_close.default, {
    close: handleClose,
    icon: iconClose
  }), props.children)), el.current);
};

DesktopSubContainer.propTypes = {
  action: _propTypes.default.string,
  handleClose: _propTypes.default.func,
  disableClose: _propTypes.default.func,
  iconClose: _propTypes.default.string.isRequired
};
var _default = DesktopSubContainer;
exports.default = _default;